export default function Suppressions(Restangular, EventCollection) {
  'ngInject';

  // Update EventCollection based on server response
  Restangular.addResponseInterceptor((data, operation, what) => {
    if (data && what === 'leave/suppress') {
      if (operation === 'post' || operation === 'put') {
        EventCollection.addOrEditEvents([data]);
      }

      if (operation === 'remove') {
        EventCollection.deleteEvent(data);
      }
    }

    return data;
  });

  return Restangular.service('leave/suppress');
}
